import type { InvoiceType } from '@core/invoices-types';
import { createEntityCollectionStore } from '@core/ngrx-legacy';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<InvoiceType>()('invoices');

export {
  actions as InvoicesCollectionActions,
  selectors as InvoicesCollectionSelectors,
  reducer as InvoicesCollectionReducer,
  namespace as InvoicesCollectionNamespace,
};
